import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { getCurrentDateTime } from '../../../../../utils';
import { Margin } from '@mui/icons-material';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 7,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const RegistrationRegisterReport = ({ data }) => {
  console.log(data, 'RegisterData');
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const user = JSON.parse(localStorage.getItem('user'));
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Registration Register Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={styles.textBold} content="Registration Register Report" />
            </View>
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '65px' }} content="Sr No." />
              <Text style={styles.columnHeader} content="Bill Date" />
              <Text style={{ ...styles.columnHeader, width: '15%' }} content="Uhid No." />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Patient Name" />
              <Text style={{ ...styles.columnHeader, width:'20%' }} content="Address" />
              <Text style={styles.columnHeader} content="City" />
              <Text style={{ ...styles.columnHeader }} content="State" />
              <Text style={{ ...styles.columnHeader, width: '100px' }} content="Category" />
              <Text style={{ ...styles.columnHeader }} content="Mobile No" />
              <Text style={{ ...styles.columnHeader, width: '100px' }} content="Ref By" />
              <Text style={{ ...styles.columnHeader, width: '130px',  }} content="Entry By" />
            </View>
            {data &&
              data.opdData.data.map((item, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '43px' }} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(item.date)} />
                  <Text style={{ ...styles.columnContent,  width: '14%', textAlign: 'left'  }} content={item.uhid} />
                  <Text style={{ ...styles.columnContent, width: '200px', textAlign: 'left' }}
                    content={`${item.name_suffix} ${item.first_name} ${item.last_name}`}
                  />
                  <Text style={{...styles.columnContent, textAlign:'left',width:'20%'}} content={item.address.address} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={item.city.city} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={item.state.state} />
                  <Text style={{ ...styles.columnContent, width: '80px' }} content={item.sponsor.name} />
                  <Text style={styles.columnContent} content={item.address.mobile} />
                  <Text style={{ ...styles.columnContent, width: '80px' }} content={item.ref_by} />
                  <Text style={{ ...styles.columnContent, width: '130px' }} content={item.createdBy} />
                </View>
              ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
